import router from '@/router';

let authorzieMogo = {
  doAuth(config) {
    if(config.replaceUrl) {
      router.replace(`/login?redirectUri=${window.encodeURIComponent(location.href)}`);
    } else {
      router.push(`/login?redirectUri=${window.encodeURIComponent(location.href)}`);
    }
  }
} 
export default authorzieMogo;


// WEBPACK FOOTER //
// ./src/store/modules/authorizeHelper/authorizeMogo.js